import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { clientPath, researchesPath } from '../../app-routing.module';

@Injectable()
export class HttpNoContentInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.status === 204) {
          let url = this.router.url;
          if (url.includes(clientPath)) {
            url = url.substring(0, url.lastIndexOf('/'));
          } else {
            url = researchesPath;
          }
          const newUrl = url + '/no-data';
          this.router.navigate([newUrl]);
        }
      })
    );
  }
}
